module.exports = __webpack_public_path__ + "static/media/48.160b8885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/48.jpg
// module id = 609
// module chunks = 0